import { useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import LeadService from "../../../../../services/LeadService";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const leadService = new LeadService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.leadName || "-"}</td>
			<td>{item?.clientName || "-"}</td>
			<td>{item?.clientPhone || "-"}</td>
			<td>{item?.clientEmail || "-"}</td>
			<td>{item?.reference || "-"}</td>
			<td>
				{item?.attachmentUrl ? (
					<a
						href={item.attachmentUrl}
						className="mx-1"
						target="_blank"
						rel="noreferrer">
						<i className="la la-file-pdf" style={{ fontSize: "2rem" }}></i>
					</a>
				) : (
					"-"
				)}
			</td>
			{/* <td>
				<Badge
					style={{ textTransform: "capitalize" }}
					variant={
						item?.status === "new"
							? "primary"
							: item?.status === "on Progress"
								? "warning"
								: item?.status === "success"
									? "success"
									: "danger"
					}>
					{item?.status || "-"}
				</Badge>
			</td> */}
			<td>
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}>
							{Translate[lang]?.edit}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							{Translate[lang]?.delete}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.leadName}
					deletedItem={item}
					modelService={leadService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};

export default CardItem;
